// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"352":"218b4f4c","935":"b7d0ac15"}[chunkId] + ".chunk.css";
};